import styled from 'styled-components'

export const RemoveTextModal = styled.div`
    font-size: 13px;
    line-height: 16px;
    div {
        color: var(--gray-800);
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .red-text {
        font-family: var(--font-bold);
        color: var(--red-500);
    }

    .fa-exclamation-circle {
        margin-right: 40px;
    }
`
